import React, { useState } from "react";
import "./signup.css";
import { Link, useNavigate } from "react-router-dom";
import { useUserAuth } from "../../Context/UseAuthContext";
import Footer from "../../components/Footer/Footer";
import ProfileNavbar from "../../components/Navbar/ProfileNavbar";

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [password, setPassword] = useState("");
  const { signUp, googleSignIn } = useUserAuth();

  let navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signUp(displayName, email, password);
      navigate("/start");
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGoogleSignIn = async (e) => {
    e.preventDefault();
    try {
      await googleSignIn();
      navigate("/start");
    } catch (error) {
      //console.log(error.message);
    }
  };

  return (
    <>
      <ProfileNavbar />
      <div className="signup">
        <h1>Set Up Your DepRelief Account</h1>
        <h2>Let us Help you Relief yourself of depression</h2>
        <div className="signup-form">
          <form onSubmit={handleSubmit}>
            {/* <label>Name</label>
          <br />
          <input
            name="name"
            type="text"
            placeholder="Name or Nickname"
            onChange={(e) => setDisplayName(e.target.value)}
          />
          <br /> */}
            <label>Email</label>
            <br />
            <input
              name="email"
              type="email"
              placeholder="Example@email.com"
              onChange={(e) => setEmail(e.target.value)}
            />
            <br />
            <label>Password</label>
            <br />
            <input
              name="password"
              type="password"
              placeholder="Enter Password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <br />
            <button className="submit-btn" type="Submit">
              Sign Up
            </button>
            <p>
              Already have an account? <Link to="/login">Log in</Link>
            </p>
            <button
              className="google-btn"
              onSubmit={handleGoogleSignIn}
              type="Submit"
            >
              Sign In With Google
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SignUp;
